<template>
  <v-row>
    <v-col cols="11" md="6" class="mx-auto">
      <div width="100%">
        <v-sheet class="overflow-y-auto" tile>
          <h2 class="ml-6">
            <faT
              icon="phone-volume"
              class="mr-2 faa-shake animated faa-slow"
              :color="dadosEmpresa.corBase"
            />
            Contatos
          </h2>
        </v-sheet>
        <template v-for="telefones in dadosEmpresa.telefones" :key="telefones">
          <div class="flex-column">
            <p class="ml-6">{{ telefones }}</p>
          </div>
        </template>
        <v-sheet class="overflow-y-auto" tile>
          <h2 class="ml-6">
            <faT
              icon="clock"
              class="mr-2 faa-shake animated faa-slow"
              :color="dadosEmpresa.corBase"
            />
            Horário de Funcionamento
          </h2>
          <p class="ml-6">Horário de Funcionamento hoje: {{ horarioAbre }}</p>
          <div>
            <v-dialog v-model="dialog">
              <template v-slot:activator="{ props }">
                <a
                  v-bind="props"
                  class="ml-6"
                  :style="'color:' + dadosEmpresa.corBase"
                >
                  Clique aqui para ver todos os horários
                </a>
              </template>
              <v-col cols="12" md="4" class="mx-auto">
                <v-card class="ml-n8">
                  <v-card-text>
                    <p v-if="segundaabre != ''">Segunda: {{ segundaabre }}</p>
                    <p v-else>Segunda: Fechado</p>

                    <p v-if="tercaabre != ''">Terca: {{ tercaabre }}</p>
                    <p v-else>Terca: Fechado</p>

                    <p v-if="quartaabre != ''">Quarta: {{ quartaabre }}</p>
                    <p v-else>Quarta: Fechado</p>

                    <p v-if="quintaabre != ''">Quinta: {{ quintaabre }}</p>
                    <p v-else>Quinta: Fechado</p>

                    <p v-if="sextaabre != ''">Sexta: {{ sextaabre }}</p>
                    <p v-else>Sexta: Fechado</p>

                    <p v-if="sabadoabre != ''">Sabado: {{ sabadoabre }}</p>
                    <p v-else>Sabado: Fechado</p>

                    <p v-if="domingoabre != ''">
                      Domingo: {{ this.domingoabre }}
                    </p>
                    <p v-else>Domingo: Fechado</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      :color="dadosEmpresa.corBase"
                      block
                      @click="dialog = false"
                      >Fechar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-dialog>
          </div>
        </v-sheet>
        <v-sheet class="overflow-y-auto" tile>
          <h2 class="mt-2 ml-6">
            <faT
              icon="location-dot"
              class="mr-2 mt-2 faa-bounce animated faa-slow"
              :color="dadosEmpresa.corBase"
            />
            Endereço
          </h2>
        </v-sheet>
        <div class="flex-column">
          <p class="ml-6 pr-6">{{ dadosEmpresa.endereco }}</p>
        </div>
        <div class="mt-2 ml-6 pr-6">
          <GoogleMap
            api-key="AIzaSyDdTMrHIQbSpmCzsJFqJBCSeEjxIVuE0fY"
            style="height: 300px"
            :center="center"
            :zoom="15"
          >
            <Marker :options="{ position: center }" />
          </GoogleMap>
          <p style="font-size: 10px" class="text-red font-weight-medium">
            {{ this.version }}
          </p>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { GoogleMap, Marker } from "vue3-google-map";
import { mapGetters } from "vuex";

export default {
  name: "contatosEmpresa",
  components: { GoogleMap, Marker },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      dialog: false,
      horarioAbre: null,
      horarioFecha: null,
      domingoabre: null,
      tercaabre: null,
      quartaabre: null,
      quintaabre: null,
      sextaabre: null,
      sabadoabre: null,
      telefones: null,
      endereco: null,
    };
  },
  computed: {
    ...mapGetters([
      "database",
      "dadosEmpresa",
      "carrinho",
      "categorias",
      "horario",
      "selecionado",
      "precoTotal",
      "produtos",
      "bairros",
      "cidade",
      "metodosPgto",
      "logado",
      "finalizaPedido",
    ]),
  },
  setup() {
    const center = { lat: 40.689247, lng: -74.044502 };

    return { center };
  },
  methods: {
    async getEmpresa() {
      this.telefone = this.dadosEmpresa.telefone;

      for (var o = 0; o < this.dadosEmpresa.horarios[0].domingo.length; o++) {
        if (this.dadosEmpresa.horarios[0].domingo[o].abre != "") {
          var domingo =
            this.dadosEmpresa.horarios[0].domingo[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].domingo[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].domingo.length - 1) {
            this.domingoabre = this.domingoabre + " " + domingo;
          } else {
            this.domingoabre = this.domingoabre + " " + domingo + " ; ";
          }
          this.domingoabre = this.domingoabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].segunda.length; o++) {
        if (this.dadosEmpresa.horarios[0].segunda[o].abre != "") {
          var segunda =
            this.dadosEmpresa.horarios[0].segunda[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].segunda[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].segunda.length - 1) {
            this.segundaabre = this.segundaabre + " " + segunda;
          } else {
            this.segundaabre = this.segundaabre + " " + segunda + " ; ";
          }
          this.segundaabre = this.segundaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].terca.length; o++) {
        if (this.dadosEmpresa.horarios[0].terca[o].abre != "") {
          var terca =
            this.dadosEmpresa.horarios[0].terca[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].terca[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].terca.length - 1) {
            this.tercaabre = this.tercaabre + " " + terca;
          } else {
            this.tercaabre = this.tercaabre + " " + terca + " ; ";
          }
          this.tercaabre = this.tercaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].quarta.length; o++) {
        if (this.dadosEmpresa.horarios[0].quarta[o].abre != "") {
          var quarta =
            this.dadosEmpresa.horarios[0].quarta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].quarta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].quarta.length - 1) {
            this.quartaabre = this.quartaabre + " " + quarta;
          } else {
            this.quartaabre = this.quartaabre + " " + quarta + " ; ";
          }
          this.quartaabre = this.quartaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].quinta.length; o++) {
        if (this.dadosEmpresa.horarios[0].quinta[o].abre != "") {
          var quinta =
            this.dadosEmpresa.horarios[0].quinta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].quinta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].quinta.length - 1) {
            this.quintaabre = this.quintaabre + " " + quinta;
          } else {
            this.quintaabre = this.quintaabre + " " + quinta + " ; ";
          }
          this.quintaabre = this.quintaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].sexta.length; o++) {
        if (this.dadosEmpresa.horarios[0].sexta[o].abre != "") {
          var sexta =
            this.dadosEmpresa.horarios[0].sexta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].sexta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].sexta.length - 1) {
            this.sextaabre = this.sextaabre + " " + sexta;
          } else {
            this.sextaabre = this.sextaabre + " " + sexta + " ; ";
          }
          this.sextaabre = this.sextaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].sabado.length; o++) {
        if (this.dadosEmpresa.horarios[0].sabado[o].abre != "") {
          var sabado =
            this.dadosEmpresa.horarios[0].sabado[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].sabado[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].sabado.length - 1) {
            this.sabadoabre = this.sabadoabre + " " + sabado;
          } else {
            this.sabadoabre = this.sabadoabre + " " + sabado + " ; ";
          }
          this.sabadoabre = this.sabadoabre.replace(/[()lundefined]/g, "");
        }
      }

      var diaSemana = new Date().getDay();

      if (diaSemana == 0) {
        this.horarioAbre = this.domingoabre;
      } else if (diaSemana == 1) {
        this.horarioAbre = this.segundaabre;
      } else if (diaSemana == 2) {
        this.horarioAbre = this.tercaabre;
      } else if (diaSemana == 3) {
        this.horarioAbre = this.quartaabre;
      } else if (diaSemana == 4) {
        this.horarioAbre = this.quintaabre;
      } else if (diaSemana == 5) {
        this.horarioAbre = this.sextaabre;
      } else if (diaSemana == 6) {
        this.horarioAbre = this.sabadoabre;
      }
    },
    getHorario() {},
  },
  created() {
    this.getEmpresa();
  },
  mounted() {},
};
</script>

<style></style>
